ike-queue{
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  .queue-jumbotron{
    //display: flex;
    //flex-direction: column;
    //align-items: center;
    text-align: center;

    padding: 40px;
    width: 779px;
    background-color: $white;
    background-color: var(--white);
    border-radius: 10px;
    margin: 16px;

    /* Alerts/Modales/Shadow */
    box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.15);

    .queue-logo{
      margin: 24px 0px;
    }
    .queue-name{
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      margin: 24px 0px;
    }
    .queue-title{
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 36px;
      margin: 16px 0px;
    }
    .queue-text{
      opacity: 0.8;
    }
    .queue-progress{
      .queue-progress__toptext{
        font-size: 12px;
        line-height: 18px;
        opacity: 0.8;
        margin: 10px 0px;
      }
      .queue-progress__bar{
        width: 60%;
        height: 10px;
        display: inline-block;
        background-color: $gray-whitish;
        background-color: var(--gray-whitish);
        border-radius: 10px;
        .queue-progress__bar--inner{
          width: 10%;
          height: 100%;
          background-color: $main-color;
          background-color: var(--main-color);
          border-radius: 10px;
          display: flex;
          flex-direction: row-reverse;
          overflow: hidden;
          transition: width 1s;
          .queue-progress__bar--inner-anim{
            background-color: $white;
            background-color: var(--white);
            opacity: .2;
            //background: blue;
            width:100%;
            height: 100%;
            border-radius: 10px;

            transform: translateX(10px);
            animation: 3s linear 0s infinite queue_progress;
            @keyframes queue_progress {
              0% { transform: translateX(-100%); }
              40% { transform: translateX(0); }
              60% { transform: translateX(0); }
              100% { transform: translateX(100%); }
            }
          }
        }
      }
      .queue-progress__bottomtext{
      }
    }
    .queue-footer{
      margin-top: 60px;
      .queue-footer__logo img{
        width: 24px;
      }
      .queue-footer__text{
        font-size: 12px;
        line-height: 16px;
        opacity: 0.8;
        margin: 10px 0px;
        img{
          border-radius: 0;
          height: 12px !important;
        }
      }
    }
  }
}
